export const DOCUMENT = 'DOCUMENT_ITEM';
export const LINKED_DOCUMENT = 'LINKED_DOCUMENT_ITEM';
export const LINKED = 'LINKED';
export const POLYGON = 'Polygon';
